module.exports = __webpack_public_path__ + "static/media/sort-size-down~NZqfOkJv.ec6916b7.svg";